import React, { SVGProps } from 'react';

const SvgCalendarToday = (props: SVGProps<SVGSVGElement>) => {
	return (
		// <svg
		// 	xmlns='http://www.w3.org/2000/svg'
		// 	height='1em'
		// 	viewBox='0 0 24 24'
		// 	width='1em'
		// 	fill='currentColor'
		// 	className='svg-icon'
		// 	{...props}>
		// 	<path d='M0 0h24v24H0V0z' fill='none' />
		// 	<path d='M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v3H4V5h16zM4 21V10h16v11H4z' />
		// 	<path d='M4 5.01h16V8H4z' opacity={0.3} />
		// </svg>
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" className='svg-icon' {...props}>
			<path d="M14.2222 3.33022V3.16667C14.2222 1.69378 13.0284 0.5 11.5556 0.5C10.0827 0.5 8.88889 1.69378 8.88889 3.16667H7.11111C7.11111 1.69378 5.91733 0.5 4.44444 0.5C2.97156 0.5 1.77778 1.69378 1.77778 3.16667V3.33022C0.745778 3.69911 0 4.676 0 5.83333V13.8333C0 15.3036 1.19644 16.5 2.66667 16.5H13.3333C14.8036 16.5 16 15.3036 16 13.8333V5.83333C16 4.676 15.2542 3.69911 14.2222 3.33022ZM10.6667 3.16667C10.6667 2.676 11.064 2.27778 11.5556 2.27778C12.0471 2.27778 12.4444 2.676 12.4444 3.16667V4.94444C12.4444 5.43511 12.0471 5.83333 11.5556 5.83333C11.064 5.83333 10.6667 5.43511 10.6667 4.94444V3.16667ZM3.55556 3.16667C3.55556 2.676 3.95289 2.27778 4.44444 2.27778C4.936 2.27778 5.33333 2.676 5.33333 3.16667V4.94444C5.33333 5.43511 4.936 5.83333 4.44444 5.83333C3.95289 5.83333 3.55556 5.43511 3.55556 4.94444V3.16667ZM14.2222 13.8333C14.2222 14.3231 13.824 14.7222 13.3333 14.7222H2.66667C2.176 14.7222 1.77778 14.3231 1.77778 13.8333V8.5H14.2222V13.8333Z" fill="white" />
		</svg>
	);
}

export default SvgCalendarToday;
